import { useState } from "react";
import FAQTab      from "./FAQTab";
import TrainingTab from "./TrainingTab";
import { FAQ_SECTIONS } from "./faqData";
import { VIDEOS }       from "./trainingData";
import "./SupportHubPage.css";

type TabId = "faq" | "training";

const faqTotal    = FAQ_SECTIONS.reduce((a, s) => a + s.items.length, 0);
const videosTotal = VIDEOS.length;

export default function SupportHubPage() {
  const [activeTab, setActiveTab] = useState<TabId>(() => {
    const p = new URLSearchParams(window.location.search).get("tab");
    if (p === "training") return p;
    return "faq";
  });

  const switchTab = (tab: TabId) => {
    setActiveTab(tab);
    const url = new URL(window.location.href);
    url.searchParams.set("tab", tab);
    window.history.replaceState(null, "", url.toString());
  };

  return (
    <div className="sh-page">

      {/* ── Hero Strip ── */}
      <div className="sh-hero">
        <div className="sh-hero__inner">
          <div className="sh-hero__badge">
            <span className="sh-hero__badge-dot" />
            Support
          </div>
          <h1 className="sh-hero__title">Help Center</h1>
          <p className="sh-hero__subtitle">
            Find answers, step-by-step guides, and training materials for Find Your Ohio.
          </p>

          <div className="sh-tab-bar">
            <button
              className={`sh-tab ${activeTab === "faq" ? "sh-tab--active" : ""}`}
              onClick={() => switchTab("faq")}
            >
              <i className="fas fa-circle-question" />
              FAQs
              <span className="sh-tab__count">{faqTotal}</span>
            </button>
            <button
              className={`sh-tab ${activeTab === "training" ? "sh-tab--active" : ""}`}
              onClick={() => switchTab("training")}
            >
              <i className="fas fa-circle-play" />
              Training Videos
              <span className="sh-tab__count">{videosTotal}</span>
            </button>
          </div>
        </div>
      </div>

      {/* ── Tab Panels ── */}
      <div className="sh-content">
        {activeTab === "faq"      && <FAQTab />}
        {activeTab === "training" && <TrainingTab />}
      </div>

    </div>
  );
}
